import { RegulationDocument } from 'components/common-form/sidePanel/docToolbar/regulatory/model';
import { useAppSelector } from 'hooks/useAppSelector';
import { createSelector } from 'reselect';
import type { AppState } from 'state/state.model';
import { WorkspaceType } from 'state/workspaces/model';

import { RawDocuments } from './RawDocuments';
import { getQuoteRegulationInfosSelector, asDocuments } from './selector';

const getDocuments: (state: AppState, workspaceType: WorkspaceType, tabId: string) => RegulationDocument[] =
  createSelector([getQuoteRegulationInfosSelector], regulationInfos => {
    return asDocuments(regulationInfos?.termsheetDocument ?? []);
  });

const getDocumentHasErrors: (state: AppState, workspaceType: WorkspaceType, tabId: string) => boolean = createSelector(
  [getQuoteRegulationInfosSelector],
  regulationInfos => {
    return (
      (regulationInfos?.termsheetDocumentError?.length ?? 0) > 0 || (regulationInfos?.termsheetDocumentTimeout ?? false)
    );
  },
);
export function TermsheetDocumentsLegacy({ tabId, workspaceType }: { tabId: string; workspaceType: WorkspaceType }) {
  const documents = useAppSelector(state => getDocuments(state, workspaceType, tabId));
  const hasErrors = useAppSelector(state => getDocumentHasErrors(state, workspaceType, tabId));

  return (
    <RawDocuments
      event="Download termsheet"
      documents={documents}
      hasErrors={hasErrors}
      labelKey="form.buttons.TermsheetButton"
      e2e="download-termsheet-doc"
    />
  );
}
